// countryCodeUtils.js
// ISO 3166 Country Codes Mapping and Utility Functions

export const COUNTRY_CODES_MAP = {
	AF: {
		name: "Afghanistan",
		alpha3: "AFG",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	AX: {
		name: "Åland Islands",
		alpha3: "ALA",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	AL: {
		name: "Albania",
		alpha3: "ALB",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	DZ: {
		name: "Algeria",
		alpha3: "DZA",
		region: "Africa",
		subRegion: "Northern Africa",
	},
	AS: {
		name: "American Samoa",
		alpha3: "ASM",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	AD: {
		name: "Andorra",
		alpha3: "AND",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	AO: {
		name: "Angola",
		alpha3: "AGO",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	AI: {
		name: "Anguilla",
		alpha3: "AIA",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	AQ: { name: "Antarctica", alpha3: "ATA", region: "", subRegion: "" },
	AG: {
		name: "Antigua and Barbuda",
		alpha3: "ATG",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	AR: {
		name: "Argentina",
		alpha3: "ARG",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	AM: {
		name: "Armenia",
		alpha3: "ARM",
		region: "Asia",
		subRegion: "Western Asia",
	},
	AW: {
		name: "Aruba",
		alpha3: "ABW",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	AU: {
		name: "Australia",
		alpha3: "AUS",
		region: "Oceania",
		subRegion: "Australia and New Zealand",
	},
	AT: {
		name: "Austria",
		alpha3: "AUT",
		region: "Europe",
		subRegion: "Western Europe",
	},
	AZ: {
		name: "Azerbaijan",
		alpha3: "AZE",
		region: "Asia",
		subRegion: "Western Asia",
	},
	BS: {
		name: "Bahamas",
		alpha3: "BHS",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	BH: {
		name: "Bahrain",
		alpha3: "BHR",
		region: "Asia",
		subRegion: "Western Asia",
	},
	BD: {
		name: "Bangladesh",
		alpha3: "BGD",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	BB: {
		name: "Barbados",
		alpha3: "BRB",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	BY: {
		name: "Belarus",
		alpha3: "BLR",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	BE: {
		name: "Belgium",
		alpha3: "BEL",
		region: "Europe",
		subRegion: "Western Europe",
	},
	BZ: {
		name: "Belize",
		alpha3: "BLZ",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	BJ: {
		name: "Benin",
		alpha3: "BEN",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	BM: {
		name: "Bermuda",
		alpha3: "BMU",
		region: "Americas",
		subRegion: "Northern America",
	},
	BT: {
		name: "Bhutan",
		alpha3: "BTN",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	BO: {
		name: "Bolivia",
		alpha3: "BOL",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	BQ: {
		name: "Bonaire, Sint Eustatius and Saba",
		alpha3: "BES",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	BA: {
		name: "Bosnia and Herzegovina",
		alpha3: "BIH",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	BW: {
		name: "Botswana",
		alpha3: "BWA",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	BV: {
		name: "Bouvet Island",
		alpha3: "BVT",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	BR: {
		name: "Brazil",
		alpha3: "BRA",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	IO: {
		name: "British Indian Ocean Territory",
		alpha3: "IOT",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	BN: {
		name: "Brunei Darussalam",
		alpha3: "BRN",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	BG: {
		name: "Bulgaria",
		alpha3: "BGR",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	BF: {
		name: "Burkina Faso",
		alpha3: "BFA",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	BI: {
		name: "Burundi",
		alpha3: "BDI",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	CV: {
		name: "Cabo Verde",
		alpha3: "CPV",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	KH: {
		name: "Cambodia",
		alpha3: "KHM",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	CM: {
		name: "Cameroon",
		alpha3: "CMR",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	CA: {
		name: "Canada",
		alpha3: "CAN",
		region: "Americas",
		subRegion: "Northern America",
	},
	KY: {
		name: "Cayman Islands",
		alpha3: "CYM",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	CF: {
		name: "Central African Republic",
		alpha3: "CAF",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	TD: {
		name: "Chad",
		alpha3: "TCD",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	CL: {
		name: "Chile",
		alpha3: "CHL",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	CN: {
		name: "China",
		alpha3: "CHN",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	CX: {
		name: "Christmas Island",
		alpha3: "CXR",
		region: "Oceania",
		subRegion: "Australia and New Zealand",
	},
	CC: {
		name: "Cocos (Keeling) Islands",
		alpha3: "CCK",
		region: "Oceania",
		subRegion: "Australia and New Zealand",
	},
	CO: {
		name: "Colombia",
		alpha3: "COL",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	KM: {
		name: "Comoros",
		alpha3: "COM",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	CG: {
		name: "Congo",
		alpha3: "COG",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	CD: {
		name: "Congo, Democratic Republic",
		alpha3: "COD",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	CK: {
		name: "Cook Islands",
		alpha3: "COK",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	CR: {
		name: "Costa Rica",
		alpha3: "CRI",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	CI: {
		name: "Côte d'Ivoire",
		alpha3: "CIV",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	HR: {
		name: "Croatia",
		alpha3: "HRV",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	CU: {
		name: "Cuba",
		alpha3: "CUB",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	CW: {
		name: "Curaçao",
		alpha3: "CUW",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	CY: {
		name: "Cyprus",
		alpha3: "CYP",
		region: "Asia",
		subRegion: "Western Asia",
	},
	CZ: {
		name: "Czechia",
		alpha3: "CZE",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	DK: {
		name: "Denmark",
		alpha3: "DNK",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	DJ: {
		name: "Djibouti",
		alpha3: "DJI",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	DM: {
		name: "Dominica",
		alpha3: "DMA",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	DO: {
		name: "Dominican Republic",
		alpha3: "DOM",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	EC: {
		name: "Ecuador",
		alpha3: "ECU",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	EG: {
		name: "Egypt",
		alpha3: "EGY",
		region: "Africa",
		subRegion: "Northern Africa",
	},
	SV: {
		name: "El Salvador",
		alpha3: "SLV",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	GQ: {
		name: "Equatorial Guinea",
		alpha3: "GNQ",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	ER: {
		name: "Eritrea",
		alpha3: "ERI",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	EE: {
		name: "Estonia",
		alpha3: "EST",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	SZ: {
		name: "Eswatini",
		alpha3: "SWZ",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	ET: {
		name: "Ethiopia",
		alpha3: "ETH",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	FK: {
		name: "Falkland Islands",
		alpha3: "FLK",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	FO: {
		name: "Faroe Islands",
		alpha3: "FRO",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	FJ: {
		name: "Fiji",
		alpha3: "FJI",
		region: "Oceania",
		subRegion: "Melanesia",
	},
	FI: {
		name: "Finland",
		alpha3: "FIN",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	FR: {
		name: "France",
		alpha3: "FRA",
		region: "Europe",
		subRegion: "Western Europe",
	},
	GF: {
		name: "French Guiana",
		alpha3: "GUF",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	PF: {
		name: "French Polynesia",
		alpha3: "PYF",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	TF: {
		name: "French Southern Territories",
		alpha3: "ATF",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	GA: {
		name: "Gabon",
		alpha3: "GAB",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	GM: {
		name: "Gambia",
		alpha3: "GMB",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	GE: {
		name: "Georgia",
		alpha3: "GEO",
		region: "Asia",
		subRegion: "Western Asia",
	},
	DE: {
		name: "Germany",
		alpha3: "DEU",
		region: "Europe",
		subRegion: "Western Europe",
	},
	GH: {
		name: "Ghana",
		alpha3: "GHA",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	GI: {
		name: "Gibraltar",
		alpha3: "GIB",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	GR: {
		name: "Greece",
		alpha3: "GRC",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	GL: {
		name: "Greenland",
		alpha3: "GRL",
		region: "Americas",
		subRegion: "Northern America",
	},
	GD: {
		name: "Grenada",
		alpha3: "GRD",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	GP: {
		name: "Guadeloupe",
		alpha3: "GLP",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	GU: {
		name: "Guam",
		alpha3: "GUM",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	GT: {
		name: "Guatemala",
		alpha3: "GTM",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	GG: {
		name: "Guernsey",
		alpha3: "GGY",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	GN: {
		name: "Guinea",
		alpha3: "GIN",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	GW: {
		name: "Guinea-Bissau",
		alpha3: "GNB",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	GY: {
		name: "Guyana",
		alpha3: "GUY",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	HT: {
		name: "Haiti",
		alpha3: "HTI",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	HM: {
		name: "Heard Island and McDonald Islands",
		alpha3: "HMD",
		region: "Oceania",
		subRegion: "Australia and New Zealand",
	},
	VA: {
		name: "Holy See",
		alpha3: "VAT",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	HN: {
		name: "Honduras",
		alpha3: "HND",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	HK: {
		name: "Hong Kong",
		alpha3: "HKG",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	HU: {
		name: "Hungary",
		alpha3: "HUN",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	IS: {
		name: "Iceland",
		alpha3: "ISL",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	IN: {
		name: "India",
		alpha3: "IND",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	ID: {
		name: "Indonesia",
		alpha3: "IDN",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	IR: {
		name: "Iran",
		alpha3: "IRN",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	IQ: {
		name: "Iraq",
		alpha3: "IRQ",
		region: "Asia",
		subRegion: "Western Asia",
	},
	IE: {
		name: "Ireland",
		alpha3: "IRL",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	IM: {
		name: "Isle of Man",
		alpha3: "IMN",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	IL: {
		name: "Israel",
		alpha3: "ISR",
		region: "Asia",
		subRegion: "Western Asia",
	},
	IT: {
		name: "Italy",
		alpha3: "ITA",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	JM: {
		name: "Jamaica",
		alpha3: "JAM",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	JP: {
		name: "Japan",
		alpha3: "JPN",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	JE: {
		name: "Jersey",
		alpha3: "JEY",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	JO: {
		name: "Jordan",
		alpha3: "JOR",
		region: "Asia",
		subRegion: "Western Asia",
	},
	KZ: {
		name: "Kazakhstan",
		alpha3: "KAZ",
		region: "Asia",
		subRegion: "Central Asia",
	},
	KE: {
		name: "Kenya",
		alpha3: "KEN",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	KI: {
		name: "Kiribati",
		alpha3: "KIR",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	KP: {
		name: "North Korea",
		alpha3: "PRK",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	KR: {
		name: "South Korea",
		alpha3: "KOR",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	KW: {
		name: "Kuwait",
		alpha3: "KWT",
		region: "Asia",
		subRegion: "Western Asia",
	},
	KG: {
		name: "Kyrgyzstan",
		alpha3: "KGZ",
		region: "Asia",
		subRegion: "Central Asia",
	},
	LA: {
		name: "Laos",
		alpha3: "LAO",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	LV: {
		name: "Latvia",
		alpha3: "LVA",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	LB: {
		name: "Lebanon",
		alpha3: "LBN",
		region: "Asia",
		subRegion: "Western Asia",
	},
	LS: {
		name: "Lesotho",
		alpha3: "LSO",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	LR: {
		name: "Liberia",
		alpha3: "LBR",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	LY: {
		name: "Libya",
		alpha3: "LBY",
		region: "Africa",
		subRegion: "Northern Africa",
	},
	LI: {
		name: "Liechtenstein",
		alpha3: "LIE",
		region: "Europe",
		subRegion: "Western Europe",
	},
	LT: {
		name: "Lithuania",
		alpha3: "LTU",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	LU: {
		name: "Luxembourg",
		alpha3: "LUX",
		region: "Europe",
		subRegion: "Western Europe",
	},
	MO: {
		name: "Macao",
		alpha3: "MAC",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	MG: {
		name: "Madagascar",
		alpha3: "MDG",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	MW: {
		name: "Malawi",
		alpha3: "MWI",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	MY: {
		name: "Malaysia",
		alpha3: "MYS",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	MV: {
		name: "Maldives",
		alpha3: "MDV",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	ML: {
		name: "Mali",
		alpha3: "MLI",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	MT: {
		name: "Malta",
		alpha3: "MLT",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	MH: {
		name: "Marshall Islands",
		alpha3: "MHL",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	MQ: {
		name: "Martinique",
		alpha3: "MTQ",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	MR: {
		name: "Mauritania",
		alpha3: "MRT",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	MU: {
		name: "Mauritius",
		alpha3: "MUS",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	YT: {
		name: "Mayotte",
		alpha3: "MYT",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	MX: {
		name: "Mexico",
		alpha3: "MEX",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	FM: {
		name: "Micronesia",
		alpha3: "FSM",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	MD: {
		name: "Moldova",
		alpha3: "MDA",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	MC: {
		name: "Monaco",
		alpha3: "MCO",
		region: "Europe",
		subRegion: "Western Europe",
	},
	MN: {
		name: "Mongolia",
		alpha3: "MNG",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	ME: {
		name: "Montenegro",
		alpha3: "MNE",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	MS: {
		name: "Montserrat",
		alpha3: "MSR",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	MA: {
		name: "Morocco",
		alpha3: "MAR",
		region: "Africa",
		subRegion: "Northern Africa",
	},
	MZ: {
		name: "Mozambique",
		alpha3: "MOZ",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	MM: {
		name: "Myanmar",
		alpha3: "MMR",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	NA: {
		name: "Namibia",
		alpha3: "NAM",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	NR: {
		name: "Nauru",
		alpha3: "NRU",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	NP: {
		name: "Nepal",
		alpha3: "NPL",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	NL: {
		name: "Netherlands",
		alpha3: "NLD",
		region: "Europe",
		subRegion: "Western Europe",
	},
	NC: {
		name: "New Caledonia",
		alpha3: "NCL",
		region: "Oceania",
		subRegion: "Melanesia",
	},
	NZ: {
		name: "New Zealand",
		alpha3: "NZL",
		region: "Oceania",
		subRegion: "Australia and New Zealand",
	},
	NI: {
		name: "Nicaragua",
		alpha3: "NIC",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	NE: {
		name: "Niger",
		alpha3: "NER",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	NG: {
		name: "Nigeria",
		alpha3: "NGA",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	NU: {
		name: "Niue",
		alpha3: "NIU",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	NF: {
		name: "Norfolk Island",
		alpha3: "NFK",
		region: "Oceania",
		subRegion: "Australia and New Zealand",
	},
	MK: {
		name: "North Macedonia",
		alpha3: "MKD",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	MP: {
		name: "Northern Mariana Islands",
		alpha3: "MNP",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	NO: {
		name: "Norway",
		alpha3: "NOR",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	OM: {
		name: "Oman",
		alpha3: "OMN",
		region: "Asia",
		subRegion: "Western Asia",
	},
	PK: {
		name: "Pakistan",
		alpha3: "PAK",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	PW: {
		name: "Palau",
		alpha3: "PLW",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	PS: {
		name: "Palestine",
		alpha3: "PSE",
		region: "Asia",
		subRegion: "Western Asia",
	},
	PA: {
		name: "Panama",
		alpha3: "PAN",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	PG: {
		name: "Papua New Guinea",
		alpha3: "PNG",
		region: "Oceania",
		subRegion: "Melanesia",
	},
	PY: {
		name: "Paraguay",
		alpha3: "PRY",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	PE: {
		name: "Peru",
		alpha3: "PER",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	PH: {
		name: "Philippines",
		alpha3: "PHL",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	PN: {
		name: "Pitcairn",
		alpha3: "PCN",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	PL: {
		name: "Poland",
		alpha3: "POL",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	PT: {
		name: "Portugal",
		alpha3: "PRT",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	PR: {
		name: "Puerto Rico",
		alpha3: "PRI",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	QA: {
		name: "Qatar",
		alpha3: "QAT",
		region: "Asia",
		subRegion: "Western Asia",
	},
	RE: {
		name: "Réunion",
		alpha3: "REU",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	RO: {
		name: "Romania",
		alpha3: "ROU",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	RU: {
		name: "Russia",
		alpha3: "RUS",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	RW: {
		name: "Rwanda",
		alpha3: "RWA",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	BL: {
		name: "Saint Barthélemy",
		alpha3: "BLM",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	SH: {
		name: "Saint Helena",
		alpha3: "SHN",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	KN: {
		name: "Saint Kitts and Nevis",
		alpha3: "KNA",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	LC: {
		name: "Saint Lucia",
		alpha3: "LCA",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	MF: {
		name: "Saint Martin",
		alpha3: "MAF",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	PM: {
		name: "Saint Pierre and Miquelon",
		alpha3: "SPM",
		region: "Americas",
		subRegion: "Northern America",
	},
	VC: {
		name: "Saint Vincent and the Grenadines",
		alpha3: "VCT",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	WS: {
		name: "Samoa",
		alpha3: "WSM",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	SM: {
		name: "San Marino",
		alpha3: "SMR",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	ST: {
		name: "Sao Tome and Principe",
		alpha3: "STP",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	SA: {
		name: "Saudi Arabia",
		alpha3: "SAU",
		region: "Asia",
		subRegion: "Western Asia",
	},
	SN: {
		name: "Senegal",
		alpha3: "SEN",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	RS: {
		name: "Serbia",
		alpha3: "SRB",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	SC: {
		name: "Seychelles",
		alpha3: "SYC",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	SL: {
		name: "Sierra Leone",
		alpha3: "SLE",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	SG: {
		name: "Singapore",
		alpha3: "SGP",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	SX: {
		name: "Sint Maarten",
		alpha3: "SXM",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	SK: {
		name: "Slovakia",
		alpha3: "SVK",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	SI: {
		name: "Slovenia",
		alpha3: "SVN",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	SB: {
		name: "Solomon Islands",
		alpha3: "SLB",
		region: "Oceania",
		subRegion: "Melanesia",
	},
	SO: {
		name: "Somalia",
		alpha3: "SOM",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	ZA: {
		name: "South Africa",
		alpha3: "ZAF",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	GS: {
		name: "South Georgia",
		alpha3: "SGS",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	SS: {
		name: "South Sudan",
		alpha3: "SSD",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	ES: {
		name: "Spain",
		alpha3: "ESP",
		region: "Europe",
		subRegion: "Southern Europe",
	},
	LK: {
		name: "Sri Lanka",
		alpha3: "LKA",
		region: "Asia",
		subRegion: "Southern Asia",
	},
	SD: {
		name: "Sudan",
		alpha3: "SDN",
		region: "Africa",
		subRegion: "Northern Africa",
	},
	SR: {
		name: "Suriname",
		alpha3: "SUR",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	SJ: {
		name: "Svalbard and Jan Mayen",
		alpha3: "SJM",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	SE: {
		name: "Sweden",
		alpha3: "SWE",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	CH: {
		name: "Switzerland",
		alpha3: "CHE",
		region: "Europe",
		subRegion: "Western Europe",
	},
	SY: {
		name: "Syria",
		alpha3: "SYR",
		region: "Asia",
		subRegion: "Western Asia",
	},
	TW: {
		name: "Taiwan",
		alpha3: "TWN",
		region: "Asia",
		subRegion: "Eastern Asia",
	},
	TJ: {
		name: "Tajikistan",
		alpha3: "TJK",
		region: "Asia",
		subRegion: "Central Asia",
	},
	TZ: {
		name: "Tanzania",
		alpha3: "TZA",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	TH: {
		name: "Thailand",
		alpha3: "THA",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	TL: {
		name: "Timor-Leste",
		alpha3: "TLS",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	TG: {
		name: "Togo",
		alpha3: "TGO",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	TK: {
		name: "Tokelau",
		alpha3: "TKL",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	TO: {
		name: "Tonga",
		alpha3: "TON",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	TT: {
		name: "Trinidad and Tobago",
		alpha3: "TTO",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	TN: {
		name: "Tunisia",
		alpha3: "TUN",
		region: "Africa",
		subRegion: "Northern Africa",
	},
	TR: {
		name: "Turkey",
		alpha3: "TUR",
		region: "Asia",
		subRegion: "Western Asia",
	},
	TM: {
		name: "Turkmenistan",
		alpha3: "TKM",
		region: "Asia",
		subRegion: "Central Asia",
	},
	TC: {
		name: "Turks and Caicos Islands",
		alpha3: "TCA",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	TV: {
		name: "Tuvalu",
		alpha3: "TUV",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	UG: {
		name: "Uganda",
		alpha3: "UGA",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	UA: {
		name: "Ukraine",
		alpha3: "UKR",
		region: "Europe",
		subRegion: "Eastern Europe",
	},
	AE: {
		name: "United Arab Emirates",
		alpha3: "ARE",
		region: "Asia",
		subRegion: "Western Asia",
	},
	GB: {
		name: "United Kingdom",
		alpha3: "GBR",
		region: "Europe",
		subRegion: "Northern Europe",
	},
	US: {
		name: "United States",
		alpha3: "USA",
		region: "Americas",
		subRegion: "Northern America",
	},
	UM: {
		name: "US Minor Outlying Islands",
		alpha3: "UMI",
		region: "Oceania",
		subRegion: "Micronesia",
	},
	UY: {
		name: "Uruguay",
		alpha3: "URY",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	UZ: {
		name: "Uzbekistan",
		alpha3: "UZB",
		region: "Asia",
		subRegion: "Central Asia",
	},
	VU: {
		name: "Vanuatu",
		alpha3: "VUT",
		region: "Oceania",
		subRegion: "Melanesia",
	},
	VE: {
		name: "Venezuela",
		alpha3: "VEN",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	VN: {
		name: "Vietnam",
		alpha3: "VNM",
		region: "Asia",
		subRegion: "South-eastern Asia",
	},
	VG: {
		name: "Virgin Islands (British)",
		alpha3: "VGB",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	VI: {
		name: "Virgin Islands (U.S.)",
		alpha3: "VIR",
		region: "Americas",
		subRegion: "Latin America and the Caribbean",
	},
	WF: {
		name: "Wallis and Futuna",
		alpha3: "WLF",
		region: "Oceania",
		subRegion: "Polynesia",
	},
	EH: {
		name: "Western Sahara",
		alpha3: "ESH",
		region: "Africa",
		subRegion: "Northern Africa",
	},
	YE: {
		name: "Yemen",
		alpha3: "YEM",
		region: "Asia",
		subRegion: "Western Asia",
	},
	ZM: {
		name: "Zambia",
		alpha3: "ZMB",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
	ZW: {
		name: "Zimbabwe",
		alpha3: "ZWE",
		region: "Africa",
		subRegion: "Sub-Saharan Africa",
	},
};

/**
 * Get country information from a 2-letter country code
 * @param {string} countryCode - 2-letter ISO country code (e.g., 'US', 'GB')
 * @returns {object} Country information including name, region, and validity
 */
export const getCountryInfo = (countryCode) => {
	const code = countryCode?.toUpperCase();

	// Handle special/invalid codes
	if (!code || code.length !== 2 || /[^A-Z]/.test(code)) {
		return {
			name: `Invalid Code (${countryCode})`,
			region: "Special",
			subRegion: "Invalid",
			isSpecialCode: true,
		};
	}

	const countryInfo = COUNTRY_CODES_MAP[code];
	if (countryInfo) {
		return {
			...countryInfo,
			isSpecialCode: false,
		};
	}

	// For valid format but unknown codes
	return {
		name: `Unknown Country (${code})`,
		region: "Unknown",
		subRegion: "Unknown",
		isSpecialCode: true,
	};
};

/**
 * Group countries by region for organized display
 * @param {string[]} countryCodes - Array of country codes
 * @returns {object} Countries grouped by region
 */
export const groupCountriesByRegion = (countryCodes) => {
	const groups = {};
	countryCodes.forEach((countryCode) => {
		const countryInfo = getCountryInfo(countryCode);
		const region = countryInfo.isSpecialCode
			? "Special/Invalid Codes"
			: countryInfo.region || "Unknown";

		if (!groups[region]) {
			groups[region] = [];
		}
		groups[region].push(countryCode);
	});

	return groups;
};

/**
 * Get statistics about country codes
 * @param {string[]} countryCodes - Array of country codes
 * @returns {object} Statistics about valid/invalid codes
 */
export const getCountryStats = (countryCodes) => {
	const validCount = countryCodes.filter(
		(code) => !getCountryInfo(code).isSpecialCode,
	).length;
	const invalidCount = countryCodes.length - validCount;

	return {
		total: countryCodes.length,
		valid: validCount,
		invalid: invalidCount,
	};
};

/**
 * Search countries by code or name
 * @param {string[]} countryCodes - Array of country codes to search
 * @param {string} searchTerm - Search term
 * @returns {string[]} Filtered country codes
 */
export const searchCountries = (countryCodes, searchTerm) => {
	if (!searchTerm) return countryCodes;

	const lowerSearchTerm = searchTerm.toLowerCase();

	return countryCodes.filter((countryCode) => {
		const countryInfo = getCountryInfo(countryCode);
		return (
			countryCode.toLowerCase().includes(lowerSearchTerm) ||
			countryInfo.name.toLowerCase().includes(lowerSearchTerm) ||
			countryInfo.region.toLowerCase().includes(lowerSearchTerm) ||
			countryInfo.subRegion.toLowerCase().includes(lowerSearchTerm)
		);
	});
};

/**
 * Sort regions with special codes at the end
 * @param {string[]} regions - Array of region names
 * @returns {string[]} Sorted regions
 */
export const sortRegions = (regions) => {
	return regions.sort((a, b) => {
		// Put special codes at the end
		if (a === "Special/Invalid Codes") return 1;
		if (b === "Special/Invalid Codes") return -1;
		return a.localeCompare(b);
	});
};
